import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Detalles del contrato',
  tabs: {
    [info_tab]: 'Info',
    [contract_tab]: 'Contrato',
    [versioning_tab]: 'Versiones',
  },
  sections: {
    price_info: 'Información de precio',
    contact: 'Contrato actual',
    signature_history: 'Historial de firmas',
  },
  labels: {
    not_signed: 'El contrato aún no ha sido firmado',
  },
  modals: {
    preview_contract: {
      title: 'Vista previa del contrato',
    },
    switch_to_annual: {
      title: 'Cambiar a anual',
    },
  },
  buttons: {
    save: 'Guardar',
    preview_and_sign: 'Vista previa y firmar',
    download: 'Descargar',
    switch_to_annual: 'Cambiar a anual',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Los cambios se guardaron',
  },
};
